import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { getLeaveType } from "../../../../services/RHService/LeaveTypeService";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import { addLeaveRequest } from "../../../../services/RHService/LeaveRequestService";
import getCurrentUserId from "../../../../reduxSaga/sagas/requests/currentUserId";

const LeaveRequest = () => {
  const [leaveType, setLeaveType] = useState([]);
  const [file, setFile] = useState(null);
  const [leaveTypeError, setLeaveTypeError] = useState("");
  const fileInputRef = useRef(null);

  useEffect(() => {
    getLeaveType(getCurrentUserId())
      .then((names) => {
        setLeaveType(names.success);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  //Define the state variables for the form data
  const [formData, setFormData] = useState({});

  const handleInputChange = (event) => {
    const target = event.target;
    const name = target.name;
    const value = target.type === "checkbox" ? target.checked : target.value;

    if (name === "dateDeb" || name === "dateFin") {
      const startDate = new Date(name === "dateDeb" ? value : formData.dateDeb);
      const endDate = new Date(name === "dateFin" ? value : formData.dateFin);
      const timeDiff = Math.abs(endDate.getTime() - startDate.getTime());
      const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
      setFormData({ ...formData, [name]: value, nbJrs: diffDays });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };
  const [selectedFile, setSelectedFile] = useState(null);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!formData.idLeaveType || formData.idLeaveType === "leaveType") {
      setLeaveTypeError("Veuillez saisir un Type de congé");
    } else {
      setLeaveTypeError("");
    }
    console.log(formData.idLeaveType);
    if (!formData.dateDeb || !formData.dateFin || !formData.nbJrs) {
      toastr.error(
        "Veuillez renseigner les champs Date début , Date Fin , nombre de jour et la piéce justificatif."
      );
      return;
    }
    if (new Date(formData.dateDeb) > new Date(formData.dateFin)) {
      toastr.error("La date de début doit être antérieure à la date de fin.");
      return;
    }

    formData.idEmployee = getCurrentUserId();
    // const checkIfHavePermission = await getVacationDays(userId);
    // let takenDays = parseInt(checkIfHavePermission.takenDays);
    // let rf = takenDays + parseInt(formData.nbJrs);
    // console.log(takenDays);
    // if (rf > checkIfHavePermission.remainingDays) {
    //   toastr.error("Il ne vous reste plus de jours de congé.");
    //   return;
    // }
    formData.idUser = getCurrentUserId();
    if (formData.idLeaveType && formData.idLeaveType !== "leaveType") {
      await addLeaveRequest(formData, file)
        .then((response) => {
          toastr.success("Demande envoyer avec succée.");
        })
        .catch((error) => {
          toastr.error("erreur dans l'envoie");
        });
    }
  };

  return (
    <section className="content-wrapper" style={{ marginTop: "0" }}>
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1 className="m-0"> Demander une autorisation de congé</h1>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <i class="fa-solid fa-house"></i>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/employee">Home</Link>
                </li>
                <li className="breadcrumb-item active">
                  <Link to="/employee/leaverequestslist">
                    Liste des demandes
                  </Link>
                </li>
                <li className="breadcrumb-item active">
                  {" "}
                  Demander une autorisation de congé
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <section className="content">
        <form onSubmit={handleSubmit} enctype="multipart/form-data">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card card-dark">
                  <div class="card-header">
                    <h4 class="card-title">
                      Demander une autorisation de congé
                    </h4>
                  </div>

                  <div className="row">
                    <div className="col-md-12">
                      <div className="card-body">
                        <div className="form-group">
                          <label>Type de Congé</label>
                          <select
                            className="custom-select form-control-border"
                            name="idLeaveType"
                            value={formData.idLeaveType}
                            onChange={handleInputChange}
                          >
                            <option value="leaveType">
                              --Choisir un Type de Congé--
                            </option>
                            {leaveType.map((l) => (
                              <option key={l.id} value={l.id}>
                                {l.nomConge}
                              </option>
                            ))}
                          </select>
                        </div>
                        {leaveTypeError && (
                          <p style={{ color: "red" }}>{leaveTypeError}</p>
                        )}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="card-body">
                        <div className="form-group">
                          <label>Date de début de congé</label>
                          <div className="input-group date">
                            <input
                              type="date"
                              min="1900-01-01"
                              max="2100-12-31"
                              name="dateDeb"
                              value={formData.dateDeb}
                              onChange={handleInputChange}
                              className="form-control form-control-border"
                            />
                          </div>
                        </div>
                        <div className="form-group">
                          <label>Nombre de jours</label>
                          <div className="input-group">
                            <input
                              type="number"
                              disabled
                              name="nbJrs"
                              value={formData.nbJrs}
                              onChange={handleInputChange}
                              className="form-control form-control-border"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="card-body">
                        <div className="form-group">
                          <label>Date de fin de congé</label>
                          <div className="input-group date">
                            <input
                              type="date"
                              name="dateFin"
                              value={formData.dateFin}
                              onChange={handleInputChange}
                              min="2022-01-01"
                              max="2100-12-31"
                              className="form-control form-control-border "
                            />
                          </div>
                        </div>
                        <div className="form-group">
                          <label>Remarque</label>
                          <textarea
                            type="Textarea"
                            rows="2"
                            name="remarque"
                            value={formData.remarque}
                            onChange={handleInputChange}
                            cols="33"
                            className="form-control form-control-border"
                            placeholder="Description"
                          ></textarea>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 col-lg-6">
                      <div className="card-body">
                        <div className="form-group">
                          <label
                            htmlFor="fileInput"
                            className="btn btn-dark col fileinput-button mb-2"
                          >
                            {selectedFile ? (
                              <p>{selectedFile}</p>
                            ) : (
                              <>
                                {" "}
                                <i className="fas fa-plus"></i>
                                <span>Pièce justificative</span>
                              </>
                            )}
                          </label>
                          <input
                            ref={fileInputRef}
                            id="fileInput"
                            type="file"
                            style={{ display: "none" }}
                            onChange={(event) => {
                              const selectedFile = event.target.files[0];
                              setFile(selectedFile);
                              setSelectedFile(selectedFile.name);
                            }}
                            accept="image/jpeg,image/png,application/pdf"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="card-footer">
            <button
              type="submit"
              className="btn btn-dark col-md-3 float-right"
              style={{ width: "auto" }}
            >
              Confirmer
            </button>
          </div>
        </form>
      </section>
    </section>
  );
};
export default LeaveRequest;
